var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _c(
      "div",
      {
        staticClass: "row p-3 mt-2 shadow-sm bg-white",
        class: { selected: _vm.bidder.adjudicatarioId === _vm.selectedBidder },
        attrs: { "data-cy": "file" }
      },
      [
        _c("div", { staticClass: "col-11" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-2", attrs: { "data-cy": "file-number" } },
              [_vm._v(" " + _vm._s(_vm.bidder.rut) + " ")]
            ),
            _c("div", { staticClass: "col-9" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-4" }, [
                  _vm._v(" " + _vm._s(_vm.bidder.nombre) + " ")
                ]),
                _c("div", { staticClass: "col-5" }, [
                  _vm._v(" " + _vm._s(_vm.bidder.giro) + " "),
                  _c("br")
                ]),
                _c("div", { staticClass: "col-3" }, [
                  _vm._v(" " + _vm._s(_vm.bidder.direccion) + " ")
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-11 offset-1" },
              [
                _c(
                  "vs-chip",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Correo",
                        expression: "'Correo'"
                      }
                    ],
                    staticClass: "mr-4",
                    attrs: { color: "#7d84ad" }
                  },
                  [
                    _c("vs-avatar", { attrs: { icon: "email" } }),
                    _vm._v(" " + _vm._s(_vm.bidder.correo) + " ")
                  ],
                  1
                ),
                _vm.bidder.telefono
                  ? _c(
                      "vs-chip",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contacto",
                            expression: "'Contacto'"
                          }
                        ],
                        staticClass: "mr-4",
                        attrs: { color: "#ff9800" }
                      },
                      [
                        _c("vs-avatar", { attrs: { icon: "person" } }),
                        _vm._v(" " + _vm._s(_vm.bidder.telefono) + " ")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.biddersStates[_vm.bidder.estadoActivo]
                  ? _c(
                      "vs-chip",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Estado Adjudicatario",
                            expression: "'Estado Adjudicatario'"
                          }
                        ],
                        attrs: {
                          "data-cy": "file-status",
                          color:
                            _vm.biddersStates[_vm.bidder.estadoActivo].color
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.biddersStates[_vm.bidder.estadoActivo].label
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-1 d-flex justify-center" },
          [
            _vm._t(
              "actions",
              [
                _c("SuccessfulBiddersOptions", {
                  ref: "file-options-" + _vm.bidder.adjudicatarioId,
                  attrs: {
                    bidder: _vm.bidder,
                    "select-bidder": _vm.selectBidder
                  },
                  on: {
                    reload: _vm.reloadList,
                    "bidder-save": _vm.handleBidderSave
                  }
                })
              ],
              { bidder: _vm.bidder }
            )
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }